import { render, staticRenderFns } from "./OrderDetailSkeleton.vue?vue&type=template&id=8e341b0e&scoped=true&"
var script = {}
import style0 from "./OrderDetailSkeleton.vue?vue&type=style&index=0&id=8e341b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e341b0e",
  null
  
)

export default component.exports